import DropdownSortingMenu from 'components/DropdownSortingMenu'
import { Container, InputBase } from 'gu-ui-kit'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'modules/Referral/List/subcomponents/List/Elements/elements.module.scss'

const FilterControls = () => {
  const dispatch = useDispatch()

  const { t } = useTranslation(['referral'])

  const { sort } = useSelector((state) => ({
    sort: state['referral/list'].list.sort,
  }))

  const filterByText = useCallback((e) => {
    dispatch({ type: 'REFERRAL/TYPE_QUERY', payload: e.currentTarget.value })
  }, [])

  return (
    <Container
      className={styles['filter__controls-wrapper']}
      display={'flex'}
      flexAlign={'center'}
    >
      <InputBase
        className={styles['filter__input']}
        type="text"
        onChange={filterByText}
        placeholder={t('list.filter_controls.filter_input.placeholder')}
      />

      <DropdownSortingMenu
        sortingRuleMap={{
          created_at: {
            asc: 'created_at.asc',
            desc: 'created_at.desc',
          },
          balance: {
            asc: 'balance.asc',
            desc: 'balance.desc',
          },
        }}
        i18nKey={'referral::list.filter_controls.sortmenu'}
        id={'accounts-list-sort-menu'}
        sorting={sort}
        onSortChange={(newSortingValue) =>
          dispatch({ type: 'REFERRAL/SET_SORTING', payload: newSortingValue })
        }
      />
    </Container>
  )
}

export default FilterControls
